import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { BrowserRouter as Router, Link } from "react-router-dom";

const navigation = [
  { name: 'Expert Consultation', href: '/expertconsultation' },
  { name: 'Generate Legal Documents', href: '/GenerateLegalDocuments' },
  { name: 'Chat with Bot', href: '/chatwithbot' },
];

const PdfUploader = () => {
  const [pdfs, setPdfs] = useState([]);
  const [selectedPdfs, setSelectedPdfs] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [folderName, setFolderName] = useState('');
  const [folders, setFolders] = useState([]);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleFileChange = (event) => {
    const files = event.target.files;
    const newPdfs = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.type === 'application/pdf') {
        const url = URL.createObjectURL(file);
        newPdfs.push({ id: Date.now() + i, name: file.name, url });
      } else {
        // Handle error if uploaded file is not a PDF
        alert('Please upload a PDF file.');
      }
    }
    setPdfs([...pdfs, ...newPdfs]);
    setShowSuccessMessage(true);
    setTimeout(() => setShowSuccessMessage(false), 3000);
  };

  const handlePdfSelect = (pdfId) => {
    setSelectedPdf(pdfId);
  };

  const handlePdfCheckboxChange = (pdfId) => {
    const selectedIndex = selectedPdfs.indexOf(pdfId);
    if (selectedIndex === -1) {
      setSelectedPdfs([...selectedPdfs, pdfId]);
    } else {
      setSelectedPdfs(selectedPdfs.filter((id) => id !== pdfId));
    }
  };

  const handleFolderCreate = () => {
    if (folderName.trim() !== '') {
      setFolders([...folders, { name: folderName, pdfs: selectedPdfs }]);
      setSelectedPdfs([]);
      setFolderName('');
    }
  };

  const handleAddToFolder = (folderIndex) => {
    const folderToUpdate = folders[folderIndex];
    const updatedPdfs = [...folderToUpdate.pdfs, ...selectedPdfs];
    const updatedFolders = [
      ...folders.slice(0, folderIndex),
      { ...folderToUpdate, pdfs: updatedPdfs },
      ...folders.slice(folderIndex + 1),
    ];
    setFolders(updatedFolders);
    setSelectedPdfs([]);
  };
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="bg-indigo-200">
        <header className="absolute inset-x-0 top-0 z-50">
            <nav className="flex items-center justify-between p-0 lg:px-8" aria-label="Global">
                
            <div className="flex lg:flex-1 items-center">
            
                    
                  <Link
                    to="/"
                    >
                    <img
                        className="h-24 w-24 mr-2"
                        src={"../new.png"}
                        alt="Legal Ease Logo"
                    />


                 </Link>
                 
                 
            </div>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open main menu</span>
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <div className="hidden lg:flex lg:gap-x-12">
                    {navigation.map((item) => (
                        <Link key={item.name} to={item.href} className="text-sm font-semibold leading-6 text-gray-900">
                            {item.name}
                        </Link>
                    ))}
                </div>
                <div className="hidden lg:flex lg:flex-1 lg:justify-end">
                    <Link to="/signin" className="text-sm font-semibold leading-6 text-gray-900">
                        Log in <span aria-hidden="true">&rarr;</span>
                    </Link>
                </div>
            </nav>
            <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
                <div className="fixed inset-0 z-50" />
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-black px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">LegalEase</span>
                            <img
                                className="h-8 w-8"
                                src="../new.jpg"
                                alt=""
                            />
                        </Link>
                        <button
                            type="button"
                            className="-m-2.5 rounded-md p-2.5 text-gray-700"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="mt-6 flow-root">
                        <div className="-my-6 divide-y divide-gray-500/10">
                            <div className="space-y-2 py-6">
                                {navigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </div>
                            <div className="py-6">
                                <Link
                                    to="/signin"
                                    className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                                >
                                    Log in
                                </Link>
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </header>
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80">
          <div
            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
      </div>
    
    <div className="flex justify-center items-center h-screen bg-indigo-200">
      <div className="flex flex-col items-center w-1/2">
        <h1 className="text-3xl font-bold mb-8">Upload and Save Your Documents</h1>
        <label htmlFor="pdf-upload" className="cursor-pointer mb-4">
          <span className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition duration-300 ease-in-out">
            Upload
          </span>
          <input id="pdf-upload" type="file" className="hidden" onChange={handleFileChange} accept="application/pdf" multiple />
        </label>
      </div>

      {showSuccessMessage && (
        <div className="absolute top-10 right-10 bg-green-500 text-white py-2 px-4 rounded-lg">
          PDF uploaded successfully!
        </div>
      )}

      {pdfs.length > 0 && (
        <div className="w-1/2">
          <h2 className="text-2xl font-bold mb-4">Select PDFs:</h2>
          <div className="mb-4">
            {pdfs.map((pdf) => (
              <label key={pdf.id} className="flex items-center">
                <input type="checkbox" className="mr-2" checked={selectedPdfs.includes(pdf.id)} onChange={() => handlePdfCheckboxChange(pdf.id)} />
                <p className="cursor-pointer text-blue-500 hover:underline" onClick={() => handlePdfSelect(pdf.id)}>{pdf.name}</p>
              </label>
            ))}
          </div>
          <div className="mb-4">
            <input type="text" placeholder="Folder Name" value={folderName} onChange={(e) => setFolderName(e.target.value)} className="border border-gray-300 rounded-lg py-2 px-4 mr-2" />
            <button onClick={handleFolderCreate} className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition duration-300 ease-in-out">Create Folder</button>
          </div>
          <h2 className="text-2xl font-bold mb-4">Folders:</h2>
          <ul>
            {folders.map((folder, index) => (
              <li key={index} className="mb-4">
                <h3 className="text-lg font-bold">{folder.name}</h3>
                <ul>
                  {folder.pdfs.map((pdfId) => {
                    const pdf = pdfs.find((pdf) => pdf.id === pdfId);
                    return <li key={pdf.id}>{pdf.name}</li>;
                  })}
                </ul>
                <button onClick={() => handleAddToFolder(index)} className="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition duration-300 ease-in-out">Add Selected PDFs</button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {selectedPdf && (
        <div className="w-1/2">
          <h2 className="text-2xl font-bold mb-4">Preview:</h2>
          <object
            data={pdfs.find((pdf) => pdf.id === selectedPdf)?.url}
            type="application/pdf"
            width="100%"
            height="500px"
            className="border border-gray-300 rounded-lg mb-4"
          >
            <p>PDF cannot be displayed. You can download it instead.</p>
          </object>
        </div>
      )}
    </div>
    <div
                    className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                    aria-hidden="true"
                >
                    <div
                        className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                        style={{
                            clipPath:
                                'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                        }}
                    />
                </div>
    <footer className="bg-indigo-200 text-black py-12 mt-20">
        <div className="container mx-auto flex flex-col items-center">
          <div className="mb-6 text-center">
            <h3 className="text-xl font-semibold mb-3">Quick Links</h3>
            <ul className="text-sm">
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/services">Our Services</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="mb-6 text-center">
            <h3 className="text-xl font-semibold mb-3">Address</h3>
            <p className="text-sm">JIET India</p>
          </div>
          <div className="text-center">
            <p className="text-sm">
              &copy; 2024 LegalEase. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>

  );
};

export default PdfUploader;